export default __webpack_public_path__ + "static/instar-homekit-8015-3694123ba2240569565abf7b7b74b061.webp";